import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex flex-col',
    backButton: 'heading-s sticky top-0 flex items-center gap-2 bg-white p-4',
    group: 'bg-bg-page mt-5 py-2 md:px-4'
  },
  variants: {
    color: {
      primary: 'text-black'
    }
  },
  defaultVariants: {
    color: 'primary'
  }
});
